import React from 'react';
import FilterChip from '../filterChip';

interface FilterChipGroupProps {
    title: string;
    items: any[];
    maxVisible?: number;
    renderChip: (item: any) => React.ReactNode;
}

const FilterChipGroup: React.FC<FilterChipGroupProps> = ({
    title,
    items,
    maxVisible = 3,
    renderChip
}) => {
    const visibleItems = items.slice(0, maxVisible);
    const remainingCount = items.length - maxVisible;

    return (
        <div className="flex flex-wrap gap-2 items-center">
            {visibleItems.map(renderChip)}
            {remainingCount > 0 && (
                <FilterChip
                    label={`... and ${remainingCount} more ${title}`}
                    onClose={() => { }}
                    hideCloseButton={true}
                    className="font-medium py-[10px] pr-3"
                />
            )}
        </div>
    );
};

export default FilterChipGroup;